<span class="sob-demanda-label" [style.fontSize]="fontSize" [title]="title" *ngIf="sobDemanda">
    <i class="fas fa-exclamation-circle"></i> Sob Demanda
</span>